import React from 'react';
import PageHero from '../components/PageHero';
import Footer from '../components/Footer';
// import AdBanner from '../components/AdBanner';

const HowItWorks = () => (
  <main className="bg-surface">
    <PageHero title="How It Works" />
    <div className="max-w-4xl mx-auto p-6 space-y-6">
      <ol className="list-decimal pl-6 space-y-2 text-gray-700">
        <li>Choose a template and upload your photos in the builder.</li>
        <li>Arrange images, add text or stickers, and preview the 3D lamp.</li>
        <li>Place your order and we 3D print your custom night lamp.</li>
      </ol>
      <img
        src="/examples/template2/temp2_examp1.png"
        alt="Design preview"
        className="mx-auto mt-4 rounded shadow max-w-md"
      />
       {/* <AdBanner /> */}
    </div>
    <Footer />
  </main>
);

export default HowItWorks;